// JsFromRoutes CacheKey 8734072b43928aca2ec6695578512710
//
// DO NOT MODIFY: This file was automatically generated by JsFromRoutes.
import { definePathHelper } from '@consumer/services/api'

export default {
  sendTestEmail: /* #__PURE__ */ definePathHelper('post', '/testing_tools/contacts/add_prompt/send_test_email'),
  create: /* #__PURE__ */ definePathHelper('post', '/testing_tools/contacts/add_prompt'),
}
